import { TReduxActions } from '../../types/redux';
import { IFiltersState } from '../../types/filters';
import { FILTERS_SELECT_ROOM_TYPE_TYPE } from '../../constants/action_types';
import { JsonQuery } from '../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function selectRoomTypeReducer(state: IFiltersState = defaultState, action: TReduxActions): IFiltersState {
  switch (action.type) {
    case FILTERS_SELECT_ROOM_TYPE_TYPE:
      const roomTypes = state.jsonQuery.room && state.jsonQuery.room.value || [];
      const nextRoomTypes = roomTypes.includes(action.roomType)
        ? roomTypes.filter((type) => type !== action.roomType)
        : roomTypes.concat(action.roomType);

      return {
        ...state,
        jsonQuery: new JsonQuery(state.jsonQuery)
          .setRoomTypes(nextRoomTypes)
          .getSerializable(),
      };
  }

  return state;
}
